const INITIAL_POS = 0;
const TOLERANCE = 100;
const END_TRANSITION_DURATION = 200;
const EMPTY_HANDLER = () => { };
const DEFAULT_CSS_CLASS = 'default-swipe';
let root = document.documentElement;
let handling = false;
const DIRECTIONS = {
  LEFT: { touchClient: 'clientX', checkHandleCondition: diff => diff < 0, pos: 'xPos', partialPos: 'partialXPos', name: 'left' },
  RIGHT: {
    touchClient: 'clientX',
    checkHandleCondition: diff => diff > 0,
    pos: 'xPos',
    partialPos: 'partialXPos',
    name: 'right'
  },
  TOP: { touchClient: 'clientY', checkHandleCondition: diff => diff < 0, pos: 'yPos', partialPos: 'partialYPos', name: 'top' },
  BOTTOM: { touchClient: 'clientY', checkHandleCondition: diff => diff > 0, pos: 'yPos', partialPos: 'partialYPos', name: 'bottom' }
};

export default {

  inserted(el, expression) {
    const data = {
      xPos: INITIAL_POS,
      partialXPos: INITIAL_POS,
      yPos: INITIAL_POS,
      partialYPos: INITIAL_POS,
      removed: false,
      ended: false,
      cssClass: DEFAULT_CSS_CLASS
    };
    let configs = [];
    let exprConfigs = expression.value.configs;

    for (let i = 0; i < exprConfigs.length; i++) {
      const element = exprConfigs[i];
      const config = {
        direction: DIRECTIONS.LEFT,
        onSwipeHandler: EMPTY_HANDLER,
        onSwipeHandlerArgs: null,
        timeoutDuration: 1000,
        tolerance: TOLERANCE,
        conditionalCheck: () => { return true; },
        remove: false
      };
      try {
        config.direction = DIRECTIONS[element.direction.toUpperCase()] || DIRECTIONS.LEFT;
      } catch (error) { }
      config.onSwipeHandler = element.handler || EMPTY_HANDLER;
      config.onSwipeHandlerArgs = element.handlerArgs;
      config.timeoutDuration = element.timeoutDuration || 0;
      config.tolerance = element.tolerance || TOLERANCE;
      config.remove = element.remove || false;
      config.conditionalCheck = element.conditionalCheck || config.conditionalCheck;
      data.eventHandler = element.eventHandler || data.eventHandler || EMPTY_HANDLER;
      data.cssClass = element.cssClass || data.cssClass;
      data.endTransitionDuration = element.endTransitionDuration || data.endTransitionDuration || END_TRANSITION_DURATION;
      configs.push(config);
      // console.log(config);
    }
    el.classList.add(data.cssClass);

    root.style.setProperty('--swipe-diff-h', '0px');
    root.style.setProperty('--swipe-diff-v', '0px');
    root.style.setProperty('--swipe-diff-percentage-h', '0');
    root.style.setProperty('--swipe-diff-percentage-v', '0');

    function handleStart(evt, configs, data) {
      // console.log('handleStart');
      // const element = evt.currentTarget;
      const touches = evt.changedTouches;
      data.xPos = touches[0].clientX;
      data.yPos = touches[0].clientY;
      data.partialXPos = 0;
      data.partialYPos = 0;
      // element.style.transition = `transform 0.1s`;
      // element.style.transform = `translate3d(0, 0, 0)`;
      data.removed = false;
      // ADD CLASS
      // element.style.transition = `transform 0.1s, max-height ${HEIGHT_TRANSITION_DURATION}ms`;
    }

    function handleEnd(evt, configs, data) {
      // console.log('handleEnd');
      if (handling) {
        return;
      }
      const element = evt.currentTarget;
      // ADD CLASS
      // if (!config.removed) {
      //   element.style.transform = `translate3d(0, 0, 0)`;
      // }
      element.classList.remove('swiping', 'swiping-left', 'swiping-right', 'swiping-top', 'swiping-bottom');
      element.classList.remove('swipe-handling', 'swipe-handling-left', 'swipe-handling-right', 'swipe-handling-top', 'swipe-handling-bottom');
      data.eventHandler.apply(this, ['swipingEnd']);

      root.style.setProperty('--swipe-diff-h', '0px');
      root.style.setProperty('--swipe-diff-v', '0px');
      root.style.setProperty('--swipe-diff-percentage-h', '0');
      root.style.setProperty('--swipe-diff-percentage-v', '0');
      // if (!data.removed) {
      //   element.style.transform = `translate3d(0, 0, 0)`;
      // }
      data.xPos = 0;
      data.yPos = 0;
    }
    function handleCancel(evt) {
      evt.preventDefault();
    }
    function handleMove(evt, configs, data) {
      const element = evt.currentTarget;
      // console.log('handleMove');

      evt.preventDefault();
      const touches = evt.changedTouches;
      for (let i = 0; i < configs.length; i++) {
        const config = configs[i];
        let diff = touches[0][config.direction.touchClient] - data[config.direction.pos];
        if (config.direction.checkHandleCondition(diff) && config.conditionalCheck() && Math.abs(diff) >= config.tolerance) {
          // element.style.transition = `transform 0.8s`;
          // ADD CLASS
          data[config.direction.pos] = touches[0][config.direction.touchClient];
          // data[config.direction.partialPos] = touches[0][config.direction.touchClient];
          setTimeout(() => {
            if (!!config.remove) {
              element.classList.add('swipe-removing');
              element.classList.add(`swipe-removing-${config.direction.name}`);
              data.eventHandler.apply(this, ['swipeRemoving', config.direction.name]);
            }
            // console.log(data.endTransitionDuration);

            setTimeout(() => {
              config.onSwipeHandler.apply(this, [config.onSwipeHandlerArgs]);
              data.eventHandler.apply(this, ['swipe-handled', config.direction.name]);
              element.classList.remove('swiping', 'swiping-left', 'swiping-right', 'swiping-top', 'swiping-bottom');
              element.classList.remove('swipe-handling', 'swipe-handling-left', 'swipe-handling-right', 'swipe-handling-top', 'swipe-handling-bottom');
              data.eventHandler.apply(this, ['swipingEnd']);

              root.style.setProperty('--swipe-diff-h', '0px');
              root.style.setProperty('--swipe-diff-v', '0px');
              root.style.setProperty('--swipe-diff-percentage-h', '0');
              root.style.setProperty('--swipe-diff-percentage-v', '0');
              handling = false;
            }, data.endTransitionDuration);
          }, config.timeoutDuration);
          // debugger;
          element.classList.add('swipe-handling');
          element.classList.add(`swipe-handling-${config.direction.name}`);
          data.eventHandler.apply(this, ['swipe-handling', config.direction.name]);
          handling = true;
          // element.style.transform = config.direction.transform;
          data.removed = true;
        } else if (config.direction.checkHandleCondition(diff) && config.conditionalCheck() && !data.removed) {
          diff = diff - data[config.direction.partialPos];

          element.classList.add(`swiping-${config.direction.name}`);
          data.eventHandler.apply(this, ['swiping', config.direction.name]);
          // element.style.transform = `translate3d(${diff}px, 0, 0)`;
          if (config.direction.name === 'left' || config.direction.name === 'right') {
            root.style.setProperty('--swipe-diff-h', `${diff}px`);
            root.style.setProperty('--swipe-diff-percentage-h', `${diff / 100}`);
          } else {
            root.style.setProperty('--swipe-diff-v', `${diff}px`);
            root.style.setProperty('--swipe-diff-percentage-v', `${diff / 100}`);
          }
        }
      }
    }
    el.addEventListener('touchstart', (e) => { handleStart(e, configs, data); }, false);
    el.addEventListener('touchend', (e) => { handleEnd(e, configs, data); }, false);
    el.addEventListener('touchcancel', (e) => { handleCancel(e, configs, data); }, false);
    el.addEventListener('touchmove', (e) => { handleMove(e, configs, data); }, false);
  }
};
